import React from "react";

export const NoWorkspacesIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="31" fill="none" viewBox="0 0 40 31">
      <rect
        width="21"
        height="29"
        x="1"
        y="30"
        fill="#fff"
        stroke="#AFB3BF"
        strokeWidth="2"
        rx="6.059"
        transform="rotate(-90 1 30)"
      ></rect>
      <rect
        width="21"
        height="29"
        x="10"
        y="22"
        fill="#fff"
        stroke="#AFB3BF"
        strokeWidth="2"
        rx="6.059"
        transform="rotate(-90 10 22)"
      ></rect>
    </svg>
  );
};
